import {Props} from './model';
import React, {Fragment} from 'react';

export default (props: Props) => {
  return <Fragment>{props.children}</Fragment>;
};
